import api from '@/libs/axios'

export default {
  getAccountInfo: () => api.get('/system/dashboard/account-info'),
}
